import React from "react";
import { PlusIcon } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next/";

import { setIsPlusIconClicked } from "./store";

import { CustomMainColorButtonWithIcon } from "@components/Common/CustomMainColorButtonWithIcon";
import { CustomMainColorIconButton } from "@components/Common/CustomMainColorIconButton";

export default function CustomSideFilter({    isAddZone,
    setIsAddZone,
    setLocalFilterActive,
    setSelectedRows,selectedRows,setIsInInitializationModalOpened,isEdited }: any) {
    const { t } = useTranslation();

    return (
        <div className="d-flex justify-content-start align-items-center ml-2">
            {isAddZone !== true ? (
                <span
                    onClick={() => {
                        setIsAddZone(!isAddZone);
                        setSelectedRows([]);
                        setLocalFilterActive(false);
                    }}
                    className="w-100 ml-2"
                >
                    <CustomMainColorButtonWithIcon
                        icon="PlusIcon"
                        iconPosition="left"
                        rounded
                        variant="primary"
                    >
                        {t("Add an area")}
                    </CustomMainColorButtonWithIcon>
                </span>
            ) : (
              
                <CustomMainColorIconButton
                icon="PlusIcon"
                rounded
                disabled={selectedRows.length === 0 ? false : true}
                onClick={() => {
                    if (isEdited === true){
                        setIsInInitializationModalOpened(true);
                       }
                    else {
                        
                        setIsPlusIconClicked(true);
                     
                    }
                }}
            >
                <PlusIcon height={20} width={20} fill="white" />
            </CustomMainColorIconButton>
               
            )}
        </div>
    );
}
